import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OrderInfo } from '../../model/request-detail.model';
import { CommonModule } from '@angular/common';
import { I18NextModule } from 'angular-i18next';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  standalone: true,
  selector: 'app-additional-info-petitioner',
  templateUrl: './additional-info-petitioner.component.html',
  styleUrls: ['./additional-info-petitioner.component.scss'],
  imports: [
    CommonModule,
    I18NextModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatTooltipModule
  ]
})
export class AdditionalInfoPetitionerComponent implements OnInit {
  @Input() isDetail?: boolean;
  @Input() orderInfo?: OrderInfo;

  @Output() dataChange = new EventEmitter<{ email: string; phone: string }>();
  @Output() additionalDataErrorEmitter = new EventEmitter<boolean>();

  constructor(private fb: FormBuilder) {}

  additionalInfoForm: FormGroup = this.fb.group({
    email: [
      '',
      [Validators.pattern('[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z]{2,4}$')]
    ],
    phone: ['', [this.nineDigitPhoneValidator()]]
  });

  ngOnInit(): void {
    this.additionalInfoForm.valueChanges.subscribe(() => {
      this.emitData();
    });
  }

  nineDigitPhoneValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (!value) {
        return null;
      }

      const digitsOnly = String(value).replace(/\s/g, '');
      const isValid = /^[0-9]{9}$/.test(digitsOnly);

      return isValid ? null : { invalidPhone: true };
    };
  }

  emitData(): void {
    if (this.additionalInfoForm.invalid) {
      this.additionalDataErrorEmitter.emit(true);
    } else {
      const cleanedPhone = String(this.additionalInfoForm.value.phone).replace(
        /\s/g,
        ''
      );
      this.additionalDataErrorEmitter.emit(false);
      this.dataChange.emit({
        email: this.additionalInfoForm.value.email,
        phone: cleanedPhone
      });
    }
  }
}
